import CertificationCatalogue from "./CertificationCatalogue";
import CertificationCoursePlanButtons from "./CertificationCoursePlanButtons";
import CertificationProgress from "./CertificationProgress";
import { useCertification } from "~/hooks";

const CertificationSidebar = () => {
	const { certification } = useCertification();

	return (
		<div className="flex flex-col gap-5">
			<CertificationProgress />

			{!certification.isStudyPlan ? <CertificationCoursePlanButtons /> : null}

			{!certification.isStudyPlan ? <CertificationCatalogue /> : null}
		</div>
	);
};

export default CertificationSidebar;
